import React from "react";
import { RouteComponentProps } from "react-router-dom";
import { MainContext } from "../contexts/MainContext";
import "./Impressum.css";

type Props = {};
type ComposedProps = Props &
  RouteComponentProps<{
    clubId: string;
  }>;

export default class Impressum extends React.Component<
  ComposedProps,
  { clubId: string }
> {
  static contextType = MainContext;
  constructor(props: any) {
    super(props);
    this.state = {
      clubId: this.props.match.params.clubId,
    };
  }

  componentDidMount = () => {
    this.context.requestClub(this.state.clubId);
  };

  render() {
    return (
      <>
        <div className="main-info-screen">
          {this.context.clubId && this.context.club.impressum && (
            <>
              <br />
              <h1>Impressum</h1>
              <span className="pre-line">{this.context.club.impressum}</span>
            </>
          )}
        </div>
      </>
    );
  }
}
